/**
 * Effective permissions of the current user (BHM-CLD-REQ-025).
 * Non-SUPERADMIN users only get explicit grants of READY modules (resolved by the API).
 */
import { create } from 'zustand';
import { api } from '../utils/api';

interface PermissionState {
  permissions: string[];
  loadedFor: string | null;
  load: (userId: string) => Promise<void>;
  reset: () => void;
}

export const usePermissionStore = create<PermissionState>()((set, get) => ({
  permissions: [],
  loadedFor: null,
  load: async (userId: string) => {
    if (get().loadedFor === userId) return;
    try {
      const { data } = await api.get<{ permissions?: string[] }>('/rbac/permissions');
      set({ permissions: Array.isArray(data.permissions) ? data.permissions : [], loadedFor: userId });
    } catch {
      set({ permissions: [], loadedFor: userId });
    }
  },
  reset: () => set({ permissions: [], loadedFor: null }),
}));
